module.exports = __webpack_public_path__ + "img/img14.ed0e1f10.svg";